import {
  createSlice,
  //createEntityAdapter
} from '@reduxjs/toolkit';
import { SiteCooperatorListItem, WorkerShift } from 'types';
import { getSiteShopList, getWorkerShift } from './thunk';

export interface InitialState {
  data?: WorkerShift[];
  cooperators?: SiteCooperatorListItem[];
  loading: boolean;
}

const initialState: InitialState = {
  data: [],
  cooperators: [],
  loading: false,
};

export const tableGanttSlice = createSlice({
  name: 'tableGantt-container',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getWorkerShift.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWorkerShift.fulfilled, (state, { payload }) => {
      state.data = payload.data;
      state.loading = false;
    });
    builder.addCase(getWorkerShift.rejected, (state) => {
      state.data = [];
      state.loading = false;
    });

    builder.addCase(getSiteShopList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSiteShopList.fulfilled, (state, { payload }) => {
      state.cooperators = payload.cooperators;
      state.loading = false;
    });
    builder.addCase(getSiteShopList.rejected, (state) => {
      state.cooperators = [];
      state.loading = false;
    });
  },
});

// export const {} = tableGanttSlice.actions;

export default tableGanttSlice.reducer;
